import { imageURL } from '../imageURL';
import baseURL from '../baseURL';

/** Uploads folder URL — prefer API host so local ports stay in sync. */
function uploadsBase() {
  const fromApi = String(baseURL || '').replace(/\/api\/?$/, '').replace(/\/$/, '');
  if (fromApi) return `${fromApi}/uploads/ledgers`;
  return String(imageURL || '').replace(/\/$/, '');
}

/** Build URL for pledge article/client photo stored as filename or legacy full path. */
export function resolvePledgePhotoUrl(stored) {
  if (stored == null || stored === '') return null;
  if (typeof stored !== 'string') return null;
  const s = stored.trim();
  if (s.startsWith('data:') || s.startsWith('http://') || s.startsWith('https://') || s.startsWith('blob:')) {
    return s;
  }
  if (s.startsWith('/uploads/')) {
    const origin = String(baseURL || '').replace(/\/api\/?$/, '').replace(/\/$/, '');
    if (origin) return `${origin}${s}`;
  }
  let file = s.replace(/^\//, '');
  if (/[\\/]/.test(file)) {
    file = file.split(/[/\\]/).pop() || file;
  }
  const base = uploadsBase();
  if (!base) return file ? `/${file}` : null;
  return `${base}/${file}`;
}

/**
 * Photos to show for a pledge in lists / eye modal.
 * Uses stored fields (API also hydrates from disk when files exist).
 */
export function pledgeDisplayPhotos(pledge) {
  if (!pledge) return { clientPhoto: null, articlePhoto: null };
  return {
    clientPhoto: pledge.clientPhoto || null,
    articlePhoto: pledge.articlePhoto || null,
  };
}
